const API_URL = process.env.REACT_APP_BACKEND_URL || "";
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem("token") || ""}`, "Content-Type": "application/json" });
async function req(path, opts = {}) {
  const r = await fetch(`${API_URL}/api${path}`, { headers: auth(), cache: "no-store", ...opts });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.detail || "Falha na requisição.");
  return d;
}
export const producaoApi = {
  receitas: () => req("/producao/receitas"),
  previa: (product_id, lotes) => req(`/producao/previa?product_id=${encodeURIComponent(product_id)}&lotes=${lotes}`),
  produzir: (body) => req("/producao", { method: "POST", body: JSON.stringify(body) }),
  historico: () => req("/producao/historico"),
  estornar: (id) => req(`/producao/${id}/estornar`, { method: "POST" }),
};
